import React from 'react';
import { ROUTE } from 'constant';
import { withRouter } from 'react-router-dom';
import Shared from 'screens/shared';

const Tiles = ({ history }) => {
  const items = [
    {
      name: 'Alarms',
      icon: 'bell',
      onClick: () => history.push(ROUTE.DASHBOARD.MONITORING_ALARMS.path),
    },
    {
      name: 'Actions',
      icon: 'paper-plane',
      onClick: () => history.push(ROUTE.DASHBOARD.MONITORING_ACTIONS.path),
    },
  ];

  return (
    <Shared.widgets.Tiles items={items} />
  );
};

export default withRouter(Tiles);
